import { BusinessType } from '../components/types';

export const BUSINESS_TYPES: Record<BusinessType, BusinessType> = {
    strategic: 'strategic',
    classic: 'classic',
    none: 'none',
};
